<register>
  <div class="register-title">新規登録</div>
  <form class="register-form" onsubmit="{ onFormSubmit }">
    <div class="form-group">
      <label class="form-label" for="mail">メールアドレス</label>
      <input class="form-control" type="email" name="mail" id="mail" autocomplete="email" required>
    </div>

    <div class="form-group">
      <label class="form-label" for="shopName">店舗名</label>
      <input class="form-control" type="text" name="shopName" id="shopName" oninput="{ handleChange('shopName') }">
    </div>
    
    <div class="form-group">
      <label class="form-label" for="officeName">事業所名
        <label class="form-label-inline">(
          <input type="checkbox" oninput="{ handleChange('sameShopName') }" checked="{ state.sameShopName }">
          店舗名と同じ)
        </label>
      </label>
      <input if="{ state.sameShopName }" class="form-control" type="text" name="officeName" id="officeName"
        value="{ state.shopName }" readonly>
      <input if="{ !state.sameShopName }" class="form-control" type="text" name="officeName" id="officeName">
    </div>

    <div class="form-group">
      <label class="form-label" for="shopType">主な営業形態</label>
      <select class="form-control" id="shopType" name="shopType" required>
        <option value="" selected> -- </option>
        <option value="0">無店舗型風俗</option>
        <option value="1">店舗型風俗</option>
        <option value="2">メンズエステ</option>
      </select>
    </div>


    <div class="form-group">
      <label class="form-label" for="shopName">店舗電話番号</label>
      <input class="form-control" type="tel" name="shopTel" id="shopTel" required>
    </div>

    <div class="form-group">
      <label class="form-label" for="numShop">店舗数</label>
      <input min="1" max="100" class="form-control-just" type="number" name="numShop" id="numShop" required>
    </div>
    <button class="register-btn btn btn-blue">登録する</button>
  </form>
  <div class="terms">
    <a href="https://cti.fuzoku-fan.jp/tcs/" target="_blank">利用規約</a> をお読みの上、「登録する」ボタンを押してください。
  </div>
  <div class="link-group">
    <a href="#login"><i class="fas fa-angle-double-left"></i>ログイン画面へ戻る</a>
  </div>
  <script>
    import { serializeForm, getEventValue } from '@/common/utils/dom';
    export default {
      state: {
        sameShopName: true,
        shopName: ''
      },

      handleChange(target) {
        return e => {
          this.state[target] = getEventValue(e);
          this.update();
        };
      },

      onMounted(props) {
        if (props.rKey) {
          props.registerUrl(props.rKey);
        }
      },

      onFormSubmit(e) {
        e.preventDefault();
        const data = serializeForm(e.target);
        if (this.state.sameShopName) {
          data.shopName = data.officeName;
        }
        data.shopType = Number(data.shopType) || 0;
        this.props.register(data);
      }
    };
  </script>
  <style type="postcss">
    .register-title {
      font-size: 1.5em;
    }

    .register-form {
      margin-top: 12px;
    }

    .register-btn {
      width: 100%;
      margin-top: 16px;
    }

    .link-group {
      margin-top: 16px;
    }

    .terms {
      margin-top: 8px;
      font-size: .9em;
    }
  </style>
</register>